const MenuItem = (label, key, icon, children) => {
    return {key, icon, children, label}
}

export default MenuItem;